import { Component, Input } from '@angular/core';
import { Process } from 'src/app/core/models/process.model';

@Component({
  selector: 'app-process-documentation',
  standalone: true,
  imports: [],
  templateUrl: './process-documentation.component.html',
  styles: ``
})
export class ProcessDocumentationComponent {
  @Input() process!: Process;
}
